function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  'use strict';

  angular.module('wsLrs.controllers').service('DashboardPermissionSvc', ['$q', 'AppPermissions', 'Dashboards', 'Logger', function ($q, AppPermissions, Dashboards, Logger) {
    var self = {
      __dashboards: null,
      __permissionMap: null,
      fetch: function fetch() {
        return Dashboards.get().then(function getDashboardsSuccess(dashboards) {
          self.__dashboards = dashboards;
          return self.fetchPermissions().then(function getPermissionsSuccess() {
            // map permissions onto each dashboard object
            _.each(self.__dashboards, function (dashboard) {
              dashboard.permissions = self.get(dashboard.id);
            });
            return self.__dashboards;
          });
        }, function getDashboardsError(response) {
          self.__dashboards = null;
          Logger.error("Dashboards fetch failed with response status " + response.status);
          return [];
        });
      },
      fetchPermissions: function fetchPermissions() {
        if (!self.__permissionMap) {
          self.__permissionMap = {};
          return AppPermissions.getPermissions('dashboard').then(function getPermissionsSuccess(dashboardPermissions) {
            self.__permissionMap = dashboardPermissions;
          });
        } else {
          return $q.resolve();
        }
      },
      get: function get(dashboardId) {
        return {
          permissions: self.getPermissions(dashboardId),
          people: self.getPeople(dashboardId),
          groups: self.getGroups(dashboardId),
          hasGlobalGroup: self.getHasGlobalGroup(dashboardId)
        };
      },
      getPermissions: function getPermissions(dashboardId) {
        return _.has(self.__permissionMap, dashboardId) ? self.__permissionMap[dashboardId].permissions : [];
      },
      getPeople: function getPeople(dashboardId) {
        return _.has(self.__permissionMap, dashboardId) ? self.__permissionMap[dashboardId].people : [];
      },
      getGroups: function getGroups(dashboardId) {
        return _.has(self.__permissionMap, dashboardId) ? self.__permissionMap[dashboardId].groups : [];
      },
      getHasGlobalGroup: function getHasGlobalGroup(dashboardId) {
        return !_.isUndefined(_.find(self.getGroups(dashboardId), function (g) {
          return g.id === -1;
        }));
      },
      save: function save(dashboardId, permissions, people, groups) {
        var entityParams = {
          value: 'dashboard',
          entityId: dashboardId,
          useActions: true
        };
        var permissionsWithActions = _.filter(permissions, function (p) {
          return p.action;
        });
        return AppPermissions.multiSave(permissionsWithActions, {
          params: entityParams
        }).then(function saveDashboardPermissionsSuccess() {
          // Remove any deleted permissions and remove the actions completely
          permissions = _.filter(permissions, function (p) {
            return p.action !== 'DELETE';
          });
          _.each(permissions, function (p) {
            delete p.action;
          });
          return self.set(dashboardId, permissions, people, groups);
        }, function saveDashboardPermissionsError(response) {
          Logger.error("Error updating dashboard permissions, response status " + response.status);
          return {};
        });
      },
      set: function set(dashboardId, permissions, people, groups) {
        if (!_.has(self.__permissionMap, dashboardId)) {
          self.__permissionMap[dashboardId] = {
            permissions: [],
            people: [],
            groups: []
          };
        }
        var entityPermissions = self.__permissionMap[dashboardId];
        if (_.isArray(permissions)) {
          entityPermissions.permissions = permissions;
        }
        if (_.isArray(people)) {
          entityPermissions.people = _.sortBy(people, 'name');
        }
        if (_.isArray(groups)) {
          entityPermissions.groups = _.sortBy(groups, 'name');
        }
        return entityPermissions;
      },
      // todo: does removing dashboard also remove its appPermissions?
      remove: function remove(dashboardId) {
        delete self.__permissionMap[dashboardId];
      },
      updateDashboards: function updateDashboards() {
        Dashboards.update();
        return self.fetch();
      }
    };
    return self;
  }]).config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/dashboards', {
      templateUrl: 'modules/app/settings/dashboards/dashboards.html',
      controller: 'DashboardsCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('DashboardsCtrl', ['$scope', 'User', 'UserRoles', function ($scope, User, UserRoles) {
    $scope.section = "dashboards";
    $scope.isAreaAdmin = UserRoles.isOrgAdmin(User.get());
  }]).controller('DashboardListCtrl', ['$scope', '$controller', '$q', '$http', 'Api', '$timeout', 'DashboardPermissionSvc', '$filter', 'wsEventNames', 'ConfirmModal', 'CardGroup', '$uibModal', 'Logger', function ($scope, $controller, $q, $http, Api, $timeout, DashboardPermissionSvc, $filter, wsEventNames, ConfirmModal, CardGroup, $uibModal, Logger) {
    $scope.dashboards = [];
    $scope.dashSortOptions = {};
    $scope.addEditDashboard = function addEditDashboard(dashboard) {
      var scope = $scope.$new();
      scope.db = dashboard;
      $uibModal.open({
        templateUrl: 'modules/app/settings/dashboards/modals/add-edit-dashboard.html',
        controller: 'DashboardModalCtrl',
        backdrop: 'static',
        size: 'dashboard-md',
        scope: scope
      });
    };
    $scope.remove = function remove(dashboardId) {
      $scope.deleteError = null;
      CardGroup.remove(dashboardId).then(function deleteDashboardSuccess() {
        DashboardPermissionSvc.remove(dashboardId);
        $scope.$emit(wsEventNames.dashboard.deleted);
      }, function deleteDashboardError(response) {
        Logger.error("An error occurred deleting dashboard with id " + dashboardId + "." + "Failed with status " + response.status);
        $scope.deleteError = "There was error in deleting the dashboard.";
      });
    };
    $scope.fetchDashboardPage = function (offset, limit) {
      $scope.limit = limit || 10;
      $scope.offset = offset || 0;
      var defer = $q.defer();
      return DashboardPermissionSvc.fetch().then(function (data) {
        var results = $filter('filter')(data, $scope.dashboardsFilter);
        var count = results.length;
        $scope.dashboards = results;
        defer.resolve({
          results: results,
          count: count
        });
        return defer.promise;
      });
    };
    $timeout(function () {
      if (typeof $scope.setDashboardPage === 'function') {
        $scope.setDashboardPage(0);
      }
    }, 10);
    $scope.search = {};
    $scope.searchText = '';
    $scope.$watch('searchText', function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    });
    function updateDashboards() {
      DashboardPermissionSvc.updateDashboards().then(function (dashboards) {
        $scope.dashboards = _.sortBy(dashboards, 'displayOrder');
        if (typeof $scope.setDashboardPage === 'function') {
          $scope.setDashboardPage(0);
        }
      }, function () {});
    }
    $scope.sortAlphabetically = function sortAlphabetically(descending) {
      $scope.dashboards = _.sortBy($scope.dashboards, 'name');
      if (descending) {
        $scope.dashboards = $scope.dashboards.reverse();
      }
    };
    $scope.dashboardsFilter = function dashboardsFilter(value) {
      return _typeof(value) === 'object' && (value.name.toLowerCase().includes($scope.searchText.toLowerCase()) || value.id.toString() === $scope.searchText);
    };
    $scope.$on(wsEventNames.dashboard.added, function dashboardAdded() {
      updateDashboards();
    });
    $scope.$on(wsEventNames.dashboard.updated, function dashboardUpdated() {
      updateDashboards();
    });
    $scope.$on(wsEventNames.dashboard.changed, function dashboardChanged() {
      updateDashboards();
    });
    $scope.$on(wsEventNames.dashboard.deleted, function dashboardDeleted() {
      updateDashboards();
    });
    $scope.formatPermissionsDisplay = function (d) {
      if (d.hasGlobalGroup) {
        return "All parts of your organization";
      } else {
        var groupDisplay, peopleDisplay;
        if (d.groups && d.groups.length > 0) {
          groupDisplay = d.groups.length + " group" + (d.groups.length > 1 ? "s" : "");
        }
        if (d.people && d.people.length > 0) {
          peopleDisplay = d.people.length + (d.people.length > 1 ? " people" : " person");
        }
        if (groupDisplay && peopleDisplay) {
          return groupDisplay + ", " + peopleDisplay;
        } else {
          if (groupDisplay) {
            return groupDisplay;
          } else {
            return peopleDisplay;
          }
        }
      }
    };
  }]).controller('DashboardModalCtrl', ['$scope', '$uibModalInstance', 'CardGroup', 'Logger', 'DashboardPermissionSvc', 'User', 'Validation', 'wsEventNames', 'UserRoles', 'PersonUtils', 'GroupUtils', '$http', 'Api', '$q', 'QuickFilterEditorModel', function ($scope, $uibModalInstance, CardGroup, Logger, PermissionSvc, User, Validation, wsEventNames, UserRoles, PersonUtils, GroupUtils, $http, Api, $q, QuickFilterEditorModel) {
    $scope.action = "Add";
    var user = User.get();

    // Create a "none" category with a value of null
    $scope.noneCategory = {
      name: "None",
      id: null
    };
    $scope.newDashboard = {
      name: "",
      organization: user.organization,
      dashboard: true,
      id: null,
      permissions: {
        permissions: [],
        people: [],
        groups: []
      },
      // If we're editing an existing dashboard ($scope.db === truthy)
      // then default to false and let them be overwritten if necessary.
      // If we're making a new dashboard, default all quickfilters to active.
      quickFilters: $scope.db ? {
        activities: {
          type: 'disabled'
        },
        people: {
          type: 'disabled'
        },
        verbs: {
          type: 'disabled'
        },
        dates: {
          type: 'disabled'
        }
      } : {
        activities: {
          type: 'all'
        },
        people: {
          type: 'all'
        },
        verbs: {
          type: 'all'
        },
        dates: {
          type: 'all'
        }
      },
      dashboardCategory: $scope.noneCategory
    };
    var dashboardPermissions = [],
      editPeople = [],
      editGroups = [],
      editPermissions = [],
      addPermissionPromise;
    $http.get(Api.url("/dashboard-categories")).then(function (r) {
      $scope.categories = r.data.results;
      $scope.categories.unshift($scope.noneCategory);

      // attach category
      if ($scope.db && $scope.db.dashboardCategoryName) {
        $scope.newDashboard.dashboardCategory = _.findWhere($scope.categories, {
          name: $scope.db.dashboardCategoryName
        });
      } else {
        $scope.newDashboard.dashboardCategory = $scope.noneCategory;
      }
    });
    if ($scope.db) {
      addPermissionPromise = $q.resolve();
      _.extend($scope.newDashboard, $scope.db);
      dashboardPermissions = $scope.db.permissions;
      editPeople = _.clone(dashboardPermissions.people);
      editGroups = _.clone(dashboardPermissions.groups);
      editPermissions = _.clone(dashboardPermissions.permissions);
      $scope.action = "Edit";
    } else if (UserRoles.isOrgManager(user)) {
      addPermissionPromise = PersonUtils.getUserPersonId().then(function (personId) {
        $scope.addPermission({
          name: user.user.name,
          id: personId
        });
      });
    }
    GroupUtils.getGroupCount().then(function (groupCount) {
      $scope.hasGroups = groupCount > 0;
    });
    $scope.editPeopleAndGroups = _.sortBy([].concat(editPeople, editGroups), 'name');
    $scope.permissionsChanged = false;
    var priorQuickFilters = angular.copy($scope.newDashboard.quickFilters);
    $scope.quickFiltersChanged = false;
    $scope.priorName = $scope.newDashboard.name;
    $scope.addPermission = function addPermission(target) {
      var newPermission = {
        value: 'dashboard',
        entityId: $scope.newDashboard.id,
        action: 'ADD'
      };
      if (_.has(target, 'childGroupIds')) {
        editGroups.push(target);
        editPermissions.push(_.extend(newPermission, {
          groupId: target.id
        }));
      } else {
        editPeople.push(target);
        editPermissions.push(_.extend(newPermission, {
          personId: target.id
        }));
      }
      $scope.editPeopleAndGroups = _.sortBy([].concat(editPeople, editGroups), 'name');
      $scope.permissionsChanged = havePermissionsChanged();
    };
    $scope.removePermission = function removePermission(target) {
      if (_.has(target, 'childGroupIds')) {
        editGroups = _.reject(editGroups, function (o) {
          return o.id === target.id;
        });
        var permissionToDelete = _.find(editPermissions, function (p) {
          return p.groupId === target.id;
        });
        if (permissionToDelete !== null) {
          permissionToDelete.action = 'DELETE';
        }
      } else {
        editPeople = _.reject(editPeople, function (o) {
          return o.id === target.id;
        });
        var _permissionToDelete = _.find(editPermissions, function (p) {
          return p.personId === target.id;
        });
        if (_permissionToDelete !== null) {
          _permissionToDelete.action = 'DELETE';
        }
      }
      $scope.editPeopleAndGroups = _.sortBy([].concat(editPeople, editGroups), 'name');
      $scope.permissionsChanged = havePermissionsChanged();
    };

    // $scope.editPeopleAndGroups is not updated prior to Add or Remove actions,
    // so we check for changes by comparing the ids in people and group arrays directly
    var havePermissionsChanged = function havePermissionsChanged() {
      var db_id = $scope.newDashboard.id;
      return !_.isEqual(_.pluck(PermissionSvc.getGroups(db_id), 'id'), _.pluck(editGroups, 'id')) || !_.isEqual(_.pluck(PermissionSvc.getPeople(db_id), 'id'), _.pluck(editPeople, 'id'));
    };
    $scope.quickFiltersChanged = function quickFiltersChanged() {
      return !_.isEqual(priorQuickFilters, $scope.newDashboard.quickFilters);
    };
    $scope.save = function save() {
      $scope.saveDashboardError = null;
      $scope.saveDashboardProgress = "Saving changes to  " + $scope.newDashboard.name + "...";
      $scope.sending = true;
      $scope.dashboardFormErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newDashboard.name
        }
      });
      if ($scope.dashboardFormErrors !== null) {
        $scope.saveDashboardProgress = null;
        $scope.sending = false;
        return;
      }

      // If we have the special null category, null out the object before persisting
      if ($scope.newDashboard.dashboardCategory !== null && $scope.newDashboard.dashboardCategory.name === $scope.noneCategory.name) {
        $scope.newDashboard.dashboardCategory = null;
      }
      QuickFilterEditorModel.saveAndIgnoreErrors();
      function saveDashboardError(response) {
        $scope.saveDashboardProgress = null;
        Logger.error("Error " + $scope.action.toLowerCase() + "ing dashboard " + $scope.newDashboard.name + ", response status " + response.status);
        $scope.saveDashboardError = "There was error " + $scope.action.toLowerCase() + "ing the dashboard.";
        if (response.status === 409) {
          $scope.saveDashboardError = "A dashboard with this name already exists in your" + " organization.";
        }
        $scope.sending = false;
      }
      function saveDashboardWrapup() {
        var event = $scope.action === "Add" ? 'added' : 'changed';
        $scope.$emit(wsEventNames.dashboard[event]);
        $uibModalInstance.close();
      }
      addPermissionPromise.then(function () {
        return CardGroup.save($scope.newDashboard, {
          params: {
            updateCategory: true
          }
        }).then(function saveDashboardSuccess(createdDashboard) {
          // update displayed dashboard object with new values
          if ($scope.db) {
            _.extend($scope.db, createdDashboard);
          }

          // if no permission changes, all done
          if (!$scope.permissionsChanged) {
            saveDashboardWrapup();
            return;
          }

          // otherwise, ensure appPermissions have proper entityId
          _.forEach(editPermissions, function (p) {
            if (_.isUndefined(p.entityId) || p.entityId === null) {
              p.entityId = createdDashboard.id;
            }
          });
          PermissionSvc.save(createdDashboard.id, editPermissions, editPeople, editGroups).then(function saveDashboardPermissionsSuccess(permissions) {
            // update dashboard with edited/saved values
            if ($scope.db) {
              $scope.db.permissions = permissions;
            } else {
              $scope.newDashboard.permissions = permissions;
            }
            saveDashboardWrapup();
          }, function saveDashboardPermissionsError() {
            $scope.saveDashboardProgress = null;
            $scope.saveDashboardError = "There was error updating the dashboard permissions.";
            $scope.sending = false;
          });
        }, saveDashboardError);
      });
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('DashboardPermissionsCtrl', ['$scope', '$controller', '$q', '$http', 'Api', 'DashboardPermissionSvc', 'Alerts', 'People', function ($scope, $controller, $q, $http, Api, DashboardPermissionSvc, Alerts, People) {
    $scope.searchPlaceholder = "Search for a person or group to see their Dashboard View Permissions.";
    $scope.permissionEntitySelected = function (entity) {
      // Get the categories and groups for the selected person/group
      var cfg = {
        value: "dashboard"
      };
      $scope.permissionEntity = entity;
      $scope.entityId = entity.id;
      $scope.originalEntity = angular.copy(entity);
      var dataCalls;
      if (entity.personas) {
        cfg.personId = entity.id;
        $scope.isPerson = true;
        dataCalls = $q.all([DashboardPermissionSvc.fetch(), People.getPeopleWithMemberships({
          params: {
            id: entity.id
          }
        })]);
      } else {
        cfg.groupId = entity.id;
        $scope.isPerson = false;
        dataCalls = $q.all([DashboardPermissionSvc.fetch()]);
      }
      dataCalls.then(function (responses) {
        $scope.dashboards = responses[0];
        $scope.isOrgAdmin = false;
        if (responses.length > 1) {
          var userWithMemberships = responses[1];
          if (userWithMemberships.count === 1 && userWithMemberships.results[0].membership && userWithMemberships.results[0].membership.role === "admin") {
            $scope.isOrgAdmin = true;
          }
        }
        // Clear out all permission info when cached locally
        _.each($scope.dashboards, function (d) {
          delete d.hasPermission;
          delete d.directPermission;
        });
        if (!$scope.isOrgAdmin) {
          var url;
          if ($scope.isPerson) {
            url = Api.url("/people/" + $scope.entityId + "/app-permissions?value=dashboard");
          } else {
            url = Api.url("/groups/" + $scope.entityId + "/app-permissions/include-implicit?value=dashboard");
          }

          // Decorate the dashboard objects with permission info from the selected person/group
          $http.get(url).then(function (response) {
            var dashboardPermissions = response.data;
            $scope.permittedDashboardsCount = dashboardPermissions.length;
            $scope.indirectPermittedDashboardsCount = 0;
            _.forEach(dashboardPermissions, function (dashboardPermission) {
              // Find the dashboard
              var dashboard = _.findWhere($scope.dashboards, {
                id: dashboardPermission.entityId
              });
              if (dashboard !== undefined && dashboard !== null) {
                dashboard.hasPermission = true;
                if ($scope.isPerson && dashboardPermission.personId && dashboardPermission.personId === $scope.entityId) {
                  dashboard.directPermission = true;
                } else if (!$scope.isPerson && dashboardPermission.groupId && dashboardPermission.groupId === $scope.entityId) {
                  dashboard.directPermission = true;
                } else {
                  $scope.indirectPermittedDashboardsCount++;
                }
              }
            });
            $scope.originalDashboards = angular.copy($scope.dashboards);
            var categories = _.groupBy($scope.dashboards, 'dashboardCategoryName');
            var categoriesArr = [];
            for (var property in categories) {
              if (categories.hasOwnProperty(property)) {
                categoriesArr.push({
                  name: property,
                  dashboards: categories[property]
                });
              }
            }
            $scope.categoryRows = makeRows(categoriesArr, 3);
          });
        }
      });
    };
    $scope.save = function () {
      var permittedDashboardIds = [];
      var dashboardIdsToRemove = [];
      _.forEach($scope.dashboards, function (dashboard) {
        if (dashboard.directPermission) {
          permittedDashboardIds.push(dashboard.id);
        } else {
          var originalDashboard = _.findWhere($scope.originalDashboards, {
            id: dashboard.id
          });
          // If it used to have direct permissions, it's been removed so EXPLICIT remove permissions
          if (originalDashboard && originalDashboard.directPermission) {
            dashboardIdsToRemove.push(dashboard.id);
          }
        }
      });
      $http.post(Api.url("/app-permissions/update-dashboard-permissions?" + ($scope.isPerson ? "personId=" : "groupId=") + $scope.entityId), {
        entityId: $scope.entityId,
        dashboardIds: permittedDashboardIds,
        dashboardIdsToRemove: dashboardIdsToRemove
      }).then(function success() {
        updateCachedPermissions($scope.originalEntity, $scope.isPerson, permittedDashboardIds);
        Alerts.raiseAlert({
          type: "success",
          text: $scope.permissionEntity.name + " dashboard permissions updated."
        });
      });
    };
    var updateCachedPermissions = function updateCachedPermissions(entity, isPerson, permittedDashboardIds) {
      _.each(DashboardPermissionSvc.__permissionMap, function (permission, dashboardId) {
        dashboardId = parseInt(dashboardId);
        // Add if missing
        if (_.contains(permittedDashboardIds, dashboardId)) {
          if (!_.contains(isPerson ? permission.peopleIds : permission.groupIds, entity.id)) {
            if (isPerson) {
              permission.peopleIds.push(entity.id);
              permission.people.push(entity);
            } else {
              permission.groupIds.push(entity.id);
              permission.groups.push(entity);
            }
          }
        } else {
          // remove if needed
          if (_.contains(isPerson ? permission.peopleIds : permission.groupIds, entity.id)) {
            if (isPerson) {
              permission.peopleIds = _.without(permission.peopleIds, entity.id);
              permission.people = _.filter(permission.people, function (person) {
                return person.id !== entity.id;
              });
            } else {
              permission.groupIds = _.without(permission.groupIds, entity.id);
              permission.groups = _.filter(permission.groups, function (group) {
                return group.id !== entity.id;
              });
            }
          }
        }
      });
    };
    $scope.cancel = function () {
      $scope.permissionEntity = null;
    };
    function makeRows(arr, size) {
      var newArr = [];
      for (var i = 0; i < arr.length; i += size) {
        newArr.push(arr.slice(i, i + size));
      }
      return newArr;
    }
  }]).controller('DashboardCategoriesCtrl', ['$scope', '$controller', '$q', '$http', 'Api', '$timeout', 'wsEventNames', '$filter', 'ConfirmModal', '$uibModal', function ($scope, $controller, $q, $http, Api, $timeout, wsEventNames, $filter, ConfirmModal, $uibModal) {
    $scope.addEditCategory = function addEditCategory(category) {
      var scope = $scope.$new();
      scope.cat = category;
      $uibModal.open({
        templateUrl: 'modules/app/settings/dashboards/modals/add-edit-category.html',
        controller: 'DashboardCategoryModalCtrl',
        backdrop: 'static',
        scope: scope
      });
    };
    $scope.deleteCategory = function deleteCategory(cat) {
      var deleteModal = {
        title: "Delete Dashboard Category " + cat.name,
        body: "Are you sure you want to delete " + cat.name + "?",
        cancelBtn: "Cancel",
        confirmBtn: "Delete",
        confirm: function confirm() {
          $http.delete(Api.url("/dashboard-categories/" + cat.id, true)).then(function () {
            //refresh UI
            if (typeof $scope.setCategoryPage === 'function') {
              $scope.setCategoryPage(0);
            }
          });
        },
        cancel: function cancel() {}
      };
      ConfirmModal.open($scope, deleteModal);
    };
    $scope.fetchCategoryPage = function (offset, limit) {
      $scope.limit = limit || 10;
      $scope.offset = offset || 0;
      var defer = $q.defer();
      return $http.get(Api.url("/dashboard-categories")).then(function (response) {
        $scope.categories = response.data.results;
        defer.resolve({
          count: $filter('filter')($scope.categories, $scope.search).length
        });
        return defer.promise;
      });
    };
    $timeout(function () {
      if (typeof $scope.setCategoryPage === 'function') {
        $scope.setCategoryPage(0);
      }
    }, 10);
    $scope.search = {};
    $scope.$watch('search.name', function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    });
    $scope.formatCategoryDashboardTooltip = function (cat) {
      var html = "<p><strong>Dashboard Category " + cat.name + " is associated<br/> with the following dashboards:</strong></p>";
      _.each(cat.dashboards, function (d) {
        html += d.name + "<br/>";
      });
      return html;
    };
    $scope.$on("category-added-event", function categoryAdded() {
      $scope.$broadcast(wsEventNames.pager.setPage, "last");
    });
  }]).controller('DashboardCategoryModalCtrl', ['$scope', '$uibModalInstance', 'CardGroup', 'Logger', 'DashboardPermissionSvc', 'User', 'Validation', 'wsEventNames', 'UserRoles', 'GroupUtils', '$http', 'Api', function ($scope, $uibModalInstance, CardGroup, Logger, PermissionSvc, User, Validation, wsEventNames, UserRoles, GroupUtils, $http, Api) {
    $scope.action = "Add";
    var user = User.get();
    $scope.newCategory = {
      name: "",
      organization: user.organization,
      id: null
    };
    if ($scope.cat) {
      _.extend($scope.newCategory, $scope.cat);
      $scope.action = "Edit";
    }
    $scope.priorName = $scope.newCategory.name;
    $scope.save = function save() {
      $scope.saveCategoryError = null;
      $scope.saveCategoryProgress = "Saving changes to  " + $scope.newCategory.name + "...";
      $scope.sending = true;
      $scope.categoryFormErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newCategory.name
        }
      });
      if ($scope.categoryFormErrors !== null) {
        $scope.saveCategoryProgress = null;
        $scope.sending = false;
        return;
      }
      function saveCategoryError(response) {
        $scope.saveCategoryProgress = null;
        Logger.error("Error " + $scope.action.toLowerCase() + "ing dashboard category " + $scope.newCategory.name + ", response status " + response.status);
        $scope.saveCategoryError = "There was error " + $scope.action.toLowerCase() + "ing the dashboard category.";
        if (response.status === 409) {
          $scope.saveCategoryError = "A dashboard category with this name already exists in your" + " organization.";
        }
        $scope.sending = false;
      }

      // If there's an id, this is an update, otherwise we are creating with a POST
      if ($scope.newCategory.id) {
        $http.put(Api.url("/dashboard-categories/" + $scope.newCategory.id, true), $scope.newCategory).then(function saveCategorySuccess() {
          $uibModalInstance.close();
          $scope.cat.name = $scope.newCategory.name;
          return;
        }, saveCategoryError);
      } else {
        $http.post(Api.url("/dashboard-categories", true), $scope.newCategory).then(function saveCategorySuccess(createdCategory) {
          // update displayed category object with new values
          if ($scope.cat) {
            _.extend($scope.cat, createdCategory);
          }
          $scope.$emit("category-added-event");
          $uibModalInstance.close();
          return;
        }, saveCategoryError);
      }
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('DashboardMenuCtrl', ['$scope', '$controller', '$q', '$http', 'Api', 'Dashboards', 'Alerts', function ($scope, $controller, $q, $http, Api, Dashboards, Alerts) {
    $http.get(Api.url("/dashboard-categories")).then(function (response) {
      // We only want non-empty categories here
      $scope.categories = response.data.results;

      //TODO: Do these parallel
      Dashboards.get().then(function (dashboards) {
        $scope.dashboards = dashboards;

        // Pull out top level menu items
        var menuItems = _.filter($scope.dashboards, function (d) {
          return d.dashboardCategoryName === "None";
        });
        menuItems = menuItems.concat($scope.categories);
        menuItems = _.sortBy(menuItems, 'menuPosition');

        // Yes, we are calling categories "dashboards" at the top level here just
        // for consistency -- at the top level it can be either dashboards or categories
        var topLevelMenu = {
          name: "Dashboard Menu",
          dashboards: menuItems,
          id: -1,
          isMainMenu: true
        };
        $scope.menuItems = [topLevelMenu];
        $scope.selectedMenu = topLevelMenu; // default upon load

        // Add all the categories as well
        $scope.menuItems = $scope.menuItems.concat($scope.categories);
      });
      $scope.$watch('selectedMenu.dashboards', function (newItem, oldItem) {
        // IF the change was simply due to selecting a different change, don't persist.  We
        // are just interested in ordering changes
        if (!newItem || !oldItem || newItem.id !== oldItem.id) {
          return;
        }
        var orderMatches = true;
        var hasUninitializedMenuItem = false;
        if (newItem.length !== oldItem.length) {
          return;
        }
        for (var i = 0; i < newItem.length; i++) {
          orderMatches = orderMatches && newItem[i].menuPosition !== 0 && newItem[i].menuPosition === oldItem[i].menuPosition;
        }
        for (var j = 0; j < newItem.length; j++) {
          if (newItem[j].menuPosition === 0) {
            hasUninitializedMenuItem = true;
            break;
          }
        }
        if (orderMatches && !hasUninitializedMenuItem) {
          return;
        }
        if ($scope.selectedMenu.isMainMenu) {
          $http.put(Api.url("/update-main-menu-order"), $scope.selectedMenu).then(function saveCategorySuccess() {
            if (!hasUninitializedMenuItem) {
              Alerts.raiseAlert({
                type: "success",
                text: "Dashboard sequence updated."
              });
              Dashboards.getMenu(true); //refresh nav bar menu
            }
          });
        } else {
          $http.put(Api.url("/dashboard-categories/" + $scope.selectedMenu.id, true), $scope.selectedMenu).then(function saveCategorySuccess() {
            if (!hasUninitializedMenuItem) {
              Alerts.raiseAlert({
                type: "success",
                text: "Dashboard sequence updated."
              });
              Dashboards.getMenu(true); //refresh nav bar menu
            }
          });
        }
      }, true);
    });
    $scope.alphabetize = function () {
      $scope.selectedMenu.dashboards = _.sortBy($scope.selectedMenu.dashboards, function (item) {
        return item.name.toLowerCase();
      });
    };
  }]).controller('DashboardAccessModalCtrl', ['$scope', '$uibModalInstance', 'CardDisplay', 'CardGroup', 'CardRegistry', 'Dashboards', 'Logger', function ($scope, $uibModalInstance, CardDisplay, CardGroup, CardRegistry, Dashboards, Logger) {
    var card = $scope.card || CardRegistry.get($scope.cardId);
    if (!$scope.cardId) {
      $scope.cardId = $scope.card.id;
    }
    $scope.cardName = card.title;
    CardGroup.getAll().then(function fetchDashboardsSuccess(res) {
      var dashboards = res.filter(function (c) {
        return c.dashboard;
      });
      var cardGroups = res.filter(function (c) {
        return !c.dashboard && c.name !== 'Your Reports';
      });
      var cardGroupCards = CardRegistry.getCardGroupCards(cardGroups.map(function (c) {
        return c.id;
      }));
      //add these to dashboards
      $scope.cardGroups = cardGroups.map(function (cg) {
        var cardGroupCard = _.find(cardGroupCards, function (cgc) {
          return cgc.configuration.cardGroupId = cg.id;
        });
        var dashs = dashboards.filter(function (d) {
          if (cardGroupCard) {
            return cardGroupCard.cardGroupIds.indexOf(d.id) > -1;
          }
          return true;
        });
        return {
          name: cg.name,
          dashboards: dashs.map(function (d) {
            return d.name;
          }),
          cardIds: cg.cardIds
        };
      });

      // // Filter out any dashboards that this card/cardgroup is already a part of
      // dashboards = _.filter(dashboards, function(d) {
      //     return !_.contains(d.cardIds, card.id);
      // });

      $scope.dashboards = _.sortBy(_.values(dashboards), 'categoryName');
    }, function fetchDashboardsError() {
      $scope.error = "There was an error fetching the dashboards.";
    });
    $scope.updateDashboard = function updateDashboard(dashboard) {
      if ($scope.containsCard(dashboard)) {
        dashboard.cardIds = _.without(dashboard.cardIds, $scope.cardId);
        card.cardGroupIds = _.without(card.cardGroupIds, dashboard.id);
      } else {
        dashboard.cardIds.push($scope.cardId);
        card.cardGroupIds.push(dashboard.id);
      }
    };
    $scope.dashboardSelected = function selectedDashboard($item) {
      $scope.updateDashboard($item);
      delete $scope.db;
    };
    $scope.dashboardTypeahead = function (query) {
      if (!query || !query.length) {
        return;
      }
      if (query === '*') {
        return $scope.dashboards;
      } else {
        query = query.toLowerCase();
        // Filter out dashboards where where is in name
        var filteredDashboards = _.filter($scope.dashboards, function (d) {
          return d.name.toLowerCase().indexOf(query) > -1;
        });
        return filteredDashboards;
      }
    };
    $scope.containsCard = function containsCard(dashboard) {
      return _.contains(dashboard.cardIds, $scope.cardId);
    };
    $scope.save = function save() {
      $scope.saveDashboardAccessError = null;
      $scope.saveDashboardAccessProgress = null;
      if (_.all($scope.dashboards, function (d) {
        return !$scope.containsCard(d);
      })) {
        $scope.saveDashboardAccessError = "At least one Dashboard must be selected.";
        return;
      }
      $scope.sending = true;
      $scope.saveDashboardAccessProgress = "Updating Dashboard access permissions...";

      // Remove the card from the display
      if (!$scope.containsCard(_.findWhere(_.values($scope.dashboards), {
        id: Dashboards.currentDashboard.id
      }))) {
        CardDisplay.removeCard($scope.cardId);
        var currentDash = Dashboards.currentDashboard.id;
        CardGroup.removeReportFromGroup(currentDash, $scope.cardId).then(function (response) {
          Dashboards.currentDashboard = response.data;
          $scope.dashboards = $scope.dashboards.filter(function (dashboard) {
            return dashboard.id !== response.data.id;
          });
          saveDashboards($scope.dashboards);
        }, function (err) {
          $scope.saveDashboardAccessProgress = null;
          Logger.error("Error removing card from dashboard, response status " + err.status);
          $scope.saveDashboardAccessError = "There was an error removing this report from dashboard " + currentDash + ".";
          $scope.sending = false;
        });
      } else {
        saveDashboards($scope.dashboards);
      }
      if ($scope.card) {
        $scope.card.dashboardDisplayString = $scope.card.cardGroupIds.map($scope.getDashboardName).join(", ");
      }
      function saveDashboards(dashboards) {
        CardGroup.multiSave({
          count: dashboards.length,
          results: dashboards
        }).then(function saveDashboardAccessSuccess() {
          // Keep the url around in case we need to delete with the PK right after adding.
          //var id = Utils.getIdFromCreatedResponse(response);

          $scope.sending = false;
          $scope.saveDashboardProgress = null;
          Dashboards.update();
          $uibModalInstance.close();
        }, function saveDashboardAccessError(response) {
          $scope.saveDashboardAccessProgress = null;
          Logger.error("Error updating Dashboard access permissions, response status " + response.status);
          $scope.saveDashboardAccessError = "There was error updating Dashboard access permissions.";
          $scope.sending = false;
        });
      }
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]);
})();
